/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import * as Sentry from '@sentry/browser';
// This set a attribute on body saying what input type the user is using. This is used to disable
// focus states when keyboard input is not used
import 'what-input';

import './src/styles/global.css';

import { RouteUpdateArgs } from 'gatsby';
import { gtm } from './src/lib/gtm';
import { getUserData } from './src/lib/gtm/hooks';
import Provider from './src/provider';

export const wrapRootElement = Provider;

export const onRouteUpdate = ({ location, prevLocation }: RouteUpdateArgs): void => {
    const triggerType = prevLocation === null ? 'hard' : 'soft';

    const getLocale = () => {
        const pathParts = location.pathname.split('/');
        const potentialLocale = pathParts[1] || '';
        // Check if it's a 2-letter language code (en, nb, etc.)
        return /^[a-zA-Z]{2}$/.test(potentialLocale) ? potentialLocale : 'nb';
    };

    const getPageType = () => {
        if (location.pathname === '/' || /^[a-zA-Z]{2}$/.test(location.pathname.split('/').at(1) || '')) {
            return 'home_page';
        }
        if (location.pathname.includes('/shop/')) {
            return 'product_page';
        }
        if (location.pathname.includes('/checkout')) {
            return 'checkout';
        }
        if (location.pathname.includes('join-our-community')) {
            return 'login';
        }
        if (location.pathname.includes('account')) {
            return 'account';
        }
        if (location.pathname.includes('summary')) {
            return 'order_confirmation';
        }

        return 'other';
    };

    setTimeout(() => {
        gtm.pageView({
            event: 'page_impression',
            page_path: location.pathname,
            page_info: {
                url:
                    typeof window !== 'undefined'
                        ? window.location.href
                        : `${location.origin}${location.pathname}`,
                virtal_url: `${location.origin}${location.pathname}`,
                page_path: `${location.pathname}`,
                page_title: typeof window !== 'undefined' ? document.title : '',
                page_type: getPageType(),
                page_referrer: typeof window !== 'undefined' ? document.referrer : '',
                trigger_type: triggerType,
                locale: getLocale(),
            },
            user_data: getUserData(),
        });
    }, 250);
};

// From https://github.com/gatsbyjs/gatsby/issues/2177#issuecomment-400976675
export const onClientEntry = async (): Promise<void> => {
    Sentry.init({
        dsn: 'https://f864c9404d5188d2874ccedbfb136874@o463742.ingest.us.sentry.io/4506914538192896',
        environment: `storefront-${process.env.GATSBY_VERCEL_ENV}`,
    });

    await new Promise((resolve, reject) => {
        // Load polyfill on browsers without fetc, That means basically just IE 11.

        (window as any).__polyfillio__ = () => {
            resolve(undefined);
        };

        if ('fetch' in window) {
            resolve(undefined);
            return;
        }

        const s = document.createElement('script');
        s.src = `https://polyfill-fastly.io/v3/polyfill.min.js?version=3.52.1&callback=__polyfillio__&features=es2017`;
        s.async = true;
        s.onerror = reject;
        document.head.appendChild(s);
    });
};
